// Spinner.js

import React from 'react';
import './Spinner.css';

const Spinner = () => (
  <div className="spinner"></div>
);

export default Spinner;